import { NoGeneralDetails, RefetchOnError } from '@energy-stacks/shared';
import { Connectors } from './Connectors';
import { useChargingStationDetails } from '../useChargingStationDetails';

export const ChargingStationDetailsConnectorsTab = () => {
  const { chargingStationDetails, isSuccess, isError, refetch } =
    useChargingStationDetails();

  return (
    <>
      {isError ? <RefetchOnError onRefetch={refetch} /> : null}
      {!chargingStationDetails && isSuccess ? (
        <NoGeneralDetails onRefetch={refetch} />
      ) : (
        <Connectors />
      )}
    </>
  );
};
